import type { ProblemCopy } from '../../api/problem.ts';

/**
 * Sentence frames reused *within* this language — not part of the catalogue, and deliberately so.
 *
 * A second language writes its own `shared.ts` with its own frames, because the frame is exactly the
 * part that does not survive translation: word order, whether the subject comes first, whether a colon
 * introduces a clause at all. What crosses the language boundary is the `Strings` type, and these
 * builders return values inside it — so English can be DRY without imposing English shape on anybody.
 */

/**
 * "Could not read this playlist. The instance sent back something Visious could not read."
 *
 * Ten screens say a version of this, and every one of them is reached the same way: an answer arrived,
 * it was valid JSON, and it was not the shape the screen needed. It used to name the field —
 * `playlist.videos[3].lengthSeconds is missing` — which is a fact about the payload and about our
 * parser, and nothing a reader can do anything with. The classification still carries it; the sentence
 * does not.
 *
 * `retryable: false` throughout: the identical request returns the identical body.
 */
export function unreadable(title: string): ProblemCopy {
  return {
    title,
    detail: 'The instance sent back something Visious could not read, so there is nothing to show here.',
    retryable: false,
  };
}
